import { useQuery } from "@tanstack/react-query";
import { fetchAvailableTimeSlots } from "../enums/queryFunction/Fetch";
import { TIME_SLOTS } from "../enums/QueryKeys";

export default function useGetAvailableTimeSlots(serviceId, date) {
  const { data, isLoading, error } = useQuery({
    queryKey: [TIME_SLOTS, serviceId, date],
    queryFn: () => fetchAvailableTimeSlots(serviceId, date),
    enabled: !!date,
  });
  return { data: data || { availableHours: [], booked: [] }, isLoading, error };
}
